var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 458.7 291.1",
    style: {
      enableBackground: "new 0 0 458.7 291.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EF7926;}\r\n\t.st1{fill:#04539C;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M34.1,265.1c0,0.5,0.3,0.8,0.9,0.8h18.1v2.7l-0.6,0.7H35c-1.4,0-2.5-0.4-3.5-1.2s-1.4-1.8-1.4-3v-9.9 c0-1.2,0.5-2.2,1.4-3s2.1-1.2,3.5-1.2h17.5l0.6,0.7v2.7H35c-0.6,0-0.9,0.3-0.9,0.8V265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M57.6,252.3c0.9-0.8,2.1-1.2,3.5-1.2h15.3c1.4,0,2.5,0.4,3.5,1.2c0.9,0.8,1.4,1.8,1.4,3v9.9 c0,1.2-0.5,2.2-1.4,3c-0.9,0.8-2.1,1.2-3.5,1.2H61.1c-1.4,0-2.5-0.4-3.5-1.2s-1.4-1.8-1.4-3v-9.9C56.3,254.1,56.7,253.1,57.6,252.3 z M77.4,255.3c0-0.5-0.3-0.8-0.9-0.8H61.1c-0.6,0-0.9,0.3-0.9,0.8v9.9c0,0.5,0.3,0.8,0.9,0.8h15.3c0.6,0,0.9-0.3,0.9-0.8V255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2,264.9v-13.8h3.9v18.2h-3.9l-17.1-13.8v13.8h-3.9v-18.2h3.9L106.2,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M117.6,257.7c0,0.5,0.3,0.8,0.9,0.8h13.3c1.6,0,2.9,0.4,3.7,1.1c0.8,0.7,1.2,1.8,1.2,3v2.5 c0,1.3-0.4,2.3-1.2,3c-0.8,0.7-2,1.1-3.7,1.1h-17.5l-0.6-0.7v-2.7h18.1c0.6,0,0.9-0.3,0.9-0.8v-2.5c0-0.5-0.3-0.8-0.9-0.8h-13.3 c-1.6,0-2.9-0.4-3.7-1.1c-0.8-0.7-1.2-1.8-1.2-3v-2.5c0-1.3,0.4-2.3,1.2-3c0.8-0.7,2-1.1,3.7-1.1h17l0.6,0.7v2.7h-17.6 c-0.6,0-0.9,0.3-0.9,0.8V257.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139,251.1h25.1v3.4h-10.6v14.8h-3.9v-14.8H139V251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.8,252.2c0.8,0.7,1.2,1.8,1.2,3v2.7c0,1.3-0.4,2.3-1.2,3c-0.8,0.7-2,1.1-3.7,1.1h-1l6.4,6.4v0.8h-4.2 l-7.1-7.2H171v7.2H167v-18.2h18.1C186.8,251.1,188,251.5,188.8,252.2z M185.1,258.8c0.6,0,0.9-0.3,0.9-0.8v-2.7 c0-0.5-0.3-0.8-0.9-0.8H171v4.3H185.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.4,251.1v14c0,1.2-0.5,2.2-1.4,3c-0.9,0.8-2.1,1.2-3.5,1.2h-15.3c-1.4,0-2.5-0.4-3.5-1.2 c-0.9-0.8-1.4-1.8-1.4-3v-14h3.9v14c0,0.5,0.3,0.8,0.9,0.8h15.4c0.6,0,0.9-0.3,0.9-0.8v-14H218.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M225.9,265.1c0,0.5,0.3,0.8,0.9,0.8H245v2.7l-0.6,0.7h-17.5c-1.4,0-2.5-0.4-3.5-1.2c-0.9-0.8-1.4-1.8-1.4-3 v-9.9c0-1.2,0.5-2.2,1.4-3c0.9-0.8,2.1-1.2,3.5-1.2h17.5l0.6,0.7v2.7h-18.1c-0.6,0-0.9,0.3-0.9,0.8V265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M247.2,251.1h25.1v3.4h-10.6v14.8h-3.9v-14.8h-10.6V251.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279.1,269.3h-3.9v-18.2h3.9V269.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.4,252.3c0.9-0.8,2.1-1.2,3.5-1.2h15.3c1.4,0,2.5,0.4,3.5,1.2s1.4,1.8,1.4,3v9.9c0,1.2-0.5,2.2-1.4,3 s-2.1,1.2-3.5,1.2h-15.3c-1.4,0-2.5-0.4-3.5-1.2c-0.9-0.8-1.4-1.8-1.4-3v-9.9C283,254.1,283.5,253.1,284.4,252.3z M304.1,255.3 c0-0.5-0.3-0.8-0.9-0.8h-15.3c-0.6,0-0.9,0.3-0.9,0.8v9.9c0,0.5,0.3,0.8,0.9,0.8h15.3c0.6,0,0.9-0.3,0.9-0.8V255.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333,264.9v-13.8h3.9v18.2H333l-17.1-13.8v13.8H312v-18.2h3.9L333,264.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M357.7,265.1c0,0.5,0.3,0.8,0.9,0.8h18.1v2.7l-0.6,0.7h-17.5c-1.4,0-2.5-0.4-3.5-1.2c-0.9-0.8-1.4-1.8-1.4-3 v-9.9c0-1.2,0.5-2.2,1.4-3c0.9-0.8,2.1-1.2,3.5-1.2h17.5l0.6,0.7v2.7h-18.1c-0.6,0-0.9,0.3-0.9,0.8V265.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M404.9,251.1v14c0,1.2-0.5,2.2-1.4,3c-0.9,0.8-2.1,1.2-3.5,1.2h-15.3c-1.4,0-2.5-0.4-3.5-1.2 c-0.9-0.8-1.4-1.8-1.4-3v-14h3.9v14c0,0.5,0.3,0.8,0.9,0.8h15.4c0.6,0,0.9-0.3,0.9-0.8v-14H404.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M426.7,251.1c1.6,0,2.9,0.4,3.7,1.1c0.8,0.7,1.2,1.8,1.2,3v2.5c0,1.3-0.4,2.3-1.2,3c-0.8,0.7-2,1.1-3.7,1.1 h-14v7.4h-3.9v-18.2H426.7z M412.7,254.5v4h14c0.6,0,0.9-0.3,0.9-0.8v-2.5c0-0.5-0.3-0.8-0.9-0.8H412.7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M53.7,202.6h37.8v16.8c0,3.1-1.2,5.7-3.5,7.6c-2.4,2-5.3,2.9-8.8,2.9H40.3c-3.5,0-6.5-1-8.8-2.9 c-2.4-2-3.5-4.5-3.5-7.6v-25.1c0-3.1,1.2-5.7,3.5-7.6c2.4-2,5.3-2.9,8.8-2.9h49.5l1.6,1.8v6.8H40.3c-1.6,0-2.4,0.7-2.4,2v25.1 c0,1.3,0.7,2,2.2,2h39c1.5,0,2.3-0.7,2.3-2v-8.2H53.7V202.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.8,183.8h10v37.6h44.2v8.6h-54.1V183.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.7,186.7c2.4-2,5.3-2.9,8.8-2.9h39c3.5,0,6.5,1,8.8,2.9c2.4,2,3.5,4.5,3.5,7.6v25.1c0,3.1-1.2,5.7-3.5,7.6 c-2.4,2-5.3,2.9-8.8,2.9h-39c-3.5,0-6.5-1-8.8-2.9c-2.4-2-3.5-4.5-3.5-7.6v-25.1C161.1,191.2,162.3,188.7,164.7,186.7z  M214.8,194.3c0-1.3-0.8-2-2.4-2h-39c-1.6,0-2.4,0.7-2.4,2v25.1c0,1.3,0.8,2,2.4,2h39c1.6,0,2.4-0.7,2.4-2V194.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M234.7,229.9v-46.2h49.9c4.2,0,7.3,0.9,9.3,2.8c2,1.9,3,4.5,3,7.7v4.5c0,1.7-0.6,3.3-1.7,4.8 c-1.1,1.5-2.9,2.6-5.4,3.3c2.4,0.7,4.2,1.7,5.4,3.2c1.2,1.5,1.7,3.1,1.7,4.7v4.5c0,3.3-1,5.9-3,7.7c-2,1.9-5.1,2.8-9.3,2.8H234.7z  M244.6,192.4v10.2h40c1.5,0,2.3-0.7,2.3-2v-6.3c0-1.3-0.8-2-2.3-2H244.6z M244.6,211.1v10.2h40c1.5,0,2.3-0.7,2.3-2v-6.3 c0-1.3-0.8-2-2.3-2H244.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M300.6,229.9V228l29.7-44.3h13L373,228v1.9h-10.8l-7.2-10.9h-37.4l-7.1,10.9H300.6z M323.3,210.5h26.1 l-13.1-19.9L323.3,210.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M378.6,183.8h10v37.6h44.2v8.6h-54.2V183.8z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M299.8,153.7h36.4V78.3l-15.3-12c0,11.2,0,62.8,0,71.6h-20"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M142,66.3c0,11.2,0,62.8,0,71.6h21.6c0-140.6,0-26.5,0-76.8l58.4-42.8l0.1,12.5c0,16.3,0,92.7,0,107.2h26.2 c0-48.9,0-70.8,0-120l53.3,39.6v96.2h-17.1c0,0,0.1-12.6,0.1-88.5l-19.3-14c0,121.6,0,78.6,0,102.5h-60.4c0-60.6,0-49,0-102.7 l-23.2,16.2c0,29.9,0,56.9,0,86.5h-56.2V78.3L142,66.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e3b207ce5229f24536d92e68118450a0.svg";
export { ForwardRef as ReactComponent };